import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

/**
 * Wrapper recharts pour un donut/pie chart. Les couleurs sont fournies
 * dans `data` (clé `color`). Si absent, on retombe sur une palette générique.
 */
export interface DonutDatum {
  key: string;
  label: string;
  value: number;
  color?: string;
}

const PALETTE = [
  '#3b82f6',
  '#10b981',
  '#f59e0b',
  '#ef4444',
  '#8b5cf6',
  '#14b8a6',
  '#f97316',
  '#6b7280',
  '#06b6d4',
  '#a855f7',
];

export interface DonutChartProps {
  data: DonutDatum[];
  height?: number;
  /** Donut si true (inner radius), sinon pie plein. */
  donut?: boolean;
  /** Affiche la légende à droite (par défaut bas). */
  legendPosition?: 'right' | 'bottom';
}

export function DonutChart({
  data,
  height = 260,
  donut = true,
  legendPosition = 'bottom',
}: DonutChartProps) {
  if (data.length === 0 || data.every((d) => d.value === 0)) {
    return <p className="text-xs text-gray-500 py-8 text-center">Aucune donnée à afficher.</p>;
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          nameKey="label"
          cx="50%"
          cy={legendPosition === 'right' ? '50%' : '45%'}
          innerRadius={donut ? '50%' : 0}
          outerRadius="80%"
          paddingAngle={2}
          isAnimationActive={false}
        >
          {data.map((entry, idx) => (
            <Cell key={entry.key} fill={entry.color ?? PALETTE[idx % PALETTE.length]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            fontSize: 12,
            borderRadius: 8,
            border: '1px solid #e5e7eb',
          }}
          formatter={(value) => new Intl.NumberFormat('fr-FR').format(Number(value))}
        />
        <Legend
          layout={legendPosition === 'right' ? 'vertical' : 'horizontal'}
          align={legendPosition === 'right' ? 'right' : 'center'}
          verticalAlign={legendPosition === 'right' ? 'middle' : 'bottom'}
          wrapperStyle={{ fontSize: 11 }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
}
